<p-dialog
  [(visible)]="visible"
  (visibleChange)="close()"
  [modal]="true"
  [header]="title | translate"
  [style]="{ width: '100%', maxWidth: '28rem' }"
  styleClass="p-0"
  [draggable]="false"
  [resizable]="false">

  <ng-template pTemplate="content">
    <form [formGroup]="form" (ngSubmit)="save()" class="flex flex-col gap-4 pt-4">
      <div class="flex flex-col gap-1">
        <label for="name" class="text-sm font-medium text-slate-700">
          {{ (isGroup ? 'speciality_group' : 'speciality') | translate }} <span class="text-red-500">*</span>
        </label>
        <input
          pInputText
          id="name"
          formControlName="name"
          [placeholder]="(isGroup ? 'speciality_group_hint_name' : 'speciality_hint_name') | translate"
          class="w-full h-12"
          [class.ng-invalid]="form.get('name')?.invalid && form.get('name')?.touched"
        />
        <small *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched" class="text-red-500 text-xs">
          {{ (isGroup ? 'speciality_group_required' : 'speciality_required') | translate }}
        </small>
        <small *ngIf="form.get('name')?.hasError('duplicate')" class="text-red-500 text-xs">
          {{ (isGroup ? 'speciality_group_name_duplicate' : 'speciality_name_duplicate') | translate: { name: form.value.name } }}
        </small>
      </div>

      <!-- Optional group, specialities only -->
      <div *ngIf="!isGroup" class="flex flex-col gap-1">
        <label for="group_id" class="text-sm font-medium text-slate-700">
          {{ 'speciality_group' | translate }}
        </label>
        <p-select
          inputId="group_id"
          formControlName="group_id"
          [options]="groups"
          optionLabel="name"
          optionValue="id"
          [showClear]="true"
          [filter]="groups.length > 6"
          appendTo="body"
          [placeholder]="'speciality_group_none' | translate"
          styleClass="w-full">
        </p-select>
        <small *ngIf="groups.length === 0" class="text-xs text-slate-400">
          {{ 'speciality_group_no_groups' | translate }}
        </small>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end gap-2 pb-2">
      <app-button
        [label]="'common_cancel' | translate"
        variant="secondary"
        (onClick)="close()">
      </app-button>
      <app-button
        [label]="'common_save' | translate"
        [loading]="loading"
        (onClick)="save()">
      </app-button>
    </div>
  </ng-template>
</p-dialog>
